<div class="seed-return-add-prod">
  <div class="prod-top-sec">
    <h2 *ngIf="!isNavModify">Decrease Early Advantage Product Quantity</h2>
    <h2 *ngIf="isNavModify">Modify Early Advantage Product Quantity</h2>
    <div class="row">
      <div class="col-12 margin-t5">
        <p>
          When modifying multiple products, this interface will take you through
          modifying each item individually
        </p>
      </div>
    </div>
  </div>

  <div class="row margin-l0 margin-r0">
    <div id="modifyTableContainer" class="tableContainer">
      <table mat-table
             [(dataSource)]="eaModifyProductDS"
             multiTemplateDataRows
             class="matTables">
        <ng-container matColumnDef="{{ column }}"
                      *ngFor="let column of displayColumns">
          <div *ngIf="column == 'productName'">
          <th mat-header-cell *matHeaderCellDef class="productName text-left">
            Product
          </th>
    </div>
    <div *ngIf="column == 'seedSize'">
      <th mat-header-cell *matHeaderCellDef class="seedSize text-center">
        Seed Size
      </th>
    </div>
    <div *ngIf="column == 'packageSize'">
      <th mat-header-cell
          *matHeaderCellDef
          class="packageSize text-center">
        Package Size
      </th>
    </div>
    <div *ngIf="column == 'treatment'">
      <th mat-header-cell *matHeaderCellDef class="treatment text-center">
        Treatment
      </th>
    </div>
    <div *ngIf="column == 'eaUnits'">
      <th mat-header-cell
          *matHeaderCellDef
          class="availableUnit text-center">
        EA Units
      </th>
    </div>
    <div *ngIf="column == 'eaModifiableUnits'">
      <th mat-header-cell
          *matHeaderCellDef
          class="dealerUnit text-center">
        EA Modifiable Units
      </th>
    </div>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="column == 'productName'" class="order-info" [attr.data-testid]="'ea-' + element.itemNumber">
        <div class="row">
          <div class="col-md-11 padding-l5"
               matTooltip="{{ element.brand }} - {{
                    element.marketingBrand
                  }} #{{ element.itemNumber }}"
               [matTooltipPosition]="'above'"
               matTooltipClass="whiteFontCpp">
            <div class="d-block d-md-none">Product</div>
            <div class="bold">
              {{element.brand}} - {{element.marketingBrand}}
            </div>
            <div class="bold d-block">{{element.itemDescription}}</div>
          </div>
        </div>
      </div>

      <div *ngIf="column == 'seedSize'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l10">
            <div class="bold text-center">{{ element.seedSize }}</div>
          </div>
        </div>
      </div>
      <div *ngIf="column == 'packageSize'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l15">
            <span matTooltip="{{ element.packageSize }}"
                  [matTooltipPosition]="'above'"
                  matTooltipClass="whiteFontCpp">
              <strong>{{ element.packageSize }}</strong>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="column == 'treatment'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l20">
            <span matTooltip="{{ element.treatment }}"
                  [matTooltipPosition]="'above'"
                  matTooltipClass="whiteFontCpp">
              <strong>{{ element.treatment }}</strong>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="column == 'eaUnits'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l15">
            <span matTooltip="{{ element.eaUnits }}"
                  [matTooltipPosition]="'above'"
                  matTooltipClass="whiteFontCpp">
              <strong>{{ element.eaUnits }}</strong>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="column == 'eaModifiableUnits'">
        <div class="order-info defaultCursor padding-l15 margin-t-15 margin-l0">
          <div>
            <button class="plus-minus-btn minusBtn"
                    (click)="dealerUnitChange('decrease', element)"
                    [attr.data-testid]="'decrease-ea-' + element.itemNumber">
              -
            </button>
            <input type="text"
                   class="geu-txt"
                   [(ngModel)]="element.eaModifiableUnits"
                   maxlength="5"
                   NumbersOnly
                   (focusout)="validateLineItem(element, 'eaUnit', 'focusout')"
                   [attr.data-testid]="'qty-ea-' + element.itemNumber"/>
            <button class="plus-minus-btn plusBtn"
                    [disabled]="!isNavModify"
                    (click)="dealerUnitChange('increase', element)"
                    (keypress)="keyPressNumbers($event)"
                    [attr.data-testid]="'increase-ea-' + element.itemNumber">
              +
            </button>
          </div>
        </div>
      </div>
    </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell
          class="product-details"
          *matCellDef="let element"
          [attr.colspan]="displayColumns.length">
        <div class="inline-error"
             *ngIf="element.lineErrors.errors.length > 0"
             id="modify_error_{{ element.lineErrors.rowId }}">
          <div class="row">
            <div class="col-md-9">
              <ol class="error-list">
                <li class="text-left" *ngFor="let err of element.lineErrors.errors">
                  {{ err.error }}
                </li>
              </ol>
            </div>
            <div class="col-md-3 revertToPrev"
                 (click)="revertToPreviousError(element, true)">
              <span>
                Revert to Previous.
                <i class="icon-ico-Reply"></i>
              </span>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="groupHeader">
      <td *matCellDef="let group"
          [attr.colspan]="displayColumns.length"
          class="groupName">
        EA Product orders for {{ group.productLine }}
      </td>
    </ng-container>
    <tr mat-row
        *matRowDef="let row; columns: ['groupHeader']; when: isGroup"
        class="d-table-row"></tr>
    <tr mat-header-row
        *matHeaderRowDef="displayColumns; sticky: true"
        class="d-none d-md-table-row"></tr>
    <tr mat-row
        *matRowDef="let element; columns: displayColumns"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        [ngClass]="element?.itemNumber ? 'displayRow' : 'd-none'"
        (click)="
            expandedElement = expandedElement === element ? null : element
          "></tr>
    <tr mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="example-detail-row"
        [style.display]="row?.itemNumber ? 'table-row' : 'none'"></tr>
    </table>
    <div *ngIf="
          eaModifyProductDS == undefined || eaModifyProductDS?.data.length == 0
        "
         class="noDataMsg">
      <p class="padding-b47">No Record Found.</p>
    </div>
    <!--<div class="row add-order-sec margin-l0 margin-r0 position-fixed">
      <div class="col-md-4 padding-l0 padding-r0">
        <button mat-raised-button class="btns margin-l5 w160" color="primary">Update Order</button>
      </div>
    </div>-->
  </div>
</div>
</div>
<!--Error section on table-->
<div class="modifyEA common-error-block new-return-request"
     *ngIf="showErrorBlock && errorMsgs.length > 0 && errorMsgs[index]?.errors?.length > 0">
  <div class="row">
    <div class="col-1 padding-r0 errCountOuter">
      <span class="errorCounting padding-5">
        {{ currentErrorRow }} of {{ errorMsgs.length }}
      </span>
    </div>
    <div class="col-7 padding-l0">
      <ul class="errorMsg">
        <li *ngFor="let err of errorMsgs[index].errors">
          <p class="padding-5">{{ err.error }}</p>
        </li>
      </ul>
    </div>
    <div class="col-4 button-sec text-right">
      <button mat-raised-button
              class="btns"
              color="primary"
              (click)="revertAllChanges()">
        Revert All Errors
      </button>
      <button mat-raised-button
              class="btns"
              color="primary"
              *ngIf="errorMsgs && errorMsgs.length > 1"
              (click)="nextError()">
        Next Error
      </button>
    </div>
  </div>
</div>
<div class="tableTotalsSec">
  <div class="row">
    <div class="col-md-9">
      <button mat-raised-button
              class="btns"
              color="primary"
              (click)="SaveChanges()">
        Update Order
      </button>
      <a class="pe-auto text-decoration-underline" style="cursor: pointer"
         (click)="onCancel()">
        Cancel
      </a>
    </div>
    <div class="col-md-3 text-right count">
      TOTAL EA UNITS:
      <span>{{ totalEaModifiableUnits }}/{{ totalEaUnits }}</span>
    </div>
  </div>
</div>
